<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="attachments" data-testid="attachment-uploader">
  <div class="row mb-sm mx-none">
    <div class="col-12 d-flex align-items-center">
      <h5 data-testid="attachment-uploader-header">{{header}}</h5>
      <ng-content select="[header-actions]"></ng-content>
    </div>
    <div class="col-12">
      <ng-container *ngIf="attachments && attachments.length > 0">
        <well-attachment-list [attachments]="attachments"
                              [canDelete]="canDelete"
                              (delete)="delete.next($event)">
        </well-attachment-list>
      </ng-container>
    </div>
  </div>

  <div class="row mx-none mb" [ngClass]="{'hide': disabled}" data-testid="attachment-upload-section">
    <div class="col-12">
      <well-attachment-upload (uploadCompleted)="onAttachmentsUploadCompleted($event)"
                              (upload)="onUpload($event)"
                              [accept]="accept"
                              [multiple]="multiple"
                              [chooseFileButtonLabel]="(browseLabel || 'attachmentUploader.browse') | translate"
                              [maxFileSize]='maxFileSize' data-testid="attachment-upload">
      </well-attachment-upload>
    </div>
  </div>

  <ng-content select="[upload]"></ng-content>
</div>


